import styled from 'styled-components';
import { color } from 'constants/styled-theme';
import { listingStatuses } from 'constants/listings';

const buttonBackgroundColor = prop => {
  if (prop.green) return color('green50');
  if (prop.gray) return color('buttonsColor');
  if (prop.ligthGray) return color('gray4');
  if (prop.white) return color('gray0');
  if (prop.red) return color('red50');
  return color('blue25');
};

const buttonColor = prop => {
  if (prop.green) return color('gray0');
  if (prop.gray) return color('gray0');
  if (prop.ligthGray) return color('gray90');
  if (prop.white) return color('gray90');
  if (prop.red) return color('gray0');
  return color('gray0');
};

export const getBidButtonColors = (listingState, isCatalog) => {
  switch (true) {
    case isCatalog:
      return listingState !== listingStatuses.ActiveBuyerUpdateBid.name
        ? { ligthGray: true }
        : { white: true };
    case !isCatalog:
      return listingState !== listingStatuses.ActiveBuyerUpdateBid.name
        ? { gray: true }
        : { white: true };
    default:
      return { gray: true };
  }
};

export const BasicButton = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  opacity: ${p => (p.disabled ? 0.4 : 1)};
  pointer-events: ${p => (p.disabled ? 'none' : 'initial')};
`;

export const Button = styled(BasicButton)`
  background: ${p => buttonBackgroundColor(p)};
  color: ${p => buttonColor(p)};
  border: ${p => p.white && `solid ${color('gray75')} 1px`};
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  font-size: 16px;
  font-family: ${props => props.theme.fonts.semiBold};
  padding: 0;
  min-width: 80px;
  white-space: nowrap;
  :hover {
    transition: 0.3s;
    opacity: 90%;
  }

  @media (max-width: ${p => p.theme.mobile}) {
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 65px;
    height: 30px;
    padding: 0;
    flex-wrap: nowrap;
  }
`;

export const LinkStyleButton = styled(BasicButton)`
  cursor: pointer;
  color: ${color('blue25')};
  background: ${color('white0')};
  text-decoration: underline;
`;

export const Link = styled.a.attrs({ target: '_blank', rel: 'noopener noreferrer' })`
  text-decoration: none;
`;

export const ButtonStyleLink = styled(Link)`
  cursor: pointer;
  opacity: ${p => (p.disabled ? 0.4 : 1)};
  pointer-events: ${p => (p.disabled ? 'none' : 'initial')};
  background: ${p => buttonBackgroundColor(p)};
  color: ${p => buttonColor(p)};
  border: ${p => p.white && `solid ${color('gray75')} 1px`};
  padding: 10px 15px;
  border-radius: 3px;
  min-width: 80px;
  :hover {
    transition: 0.3s;
    opacity: 90%;
  }
`;
